export default {
  email: '邮箱格式错误',
}
